import React,{useState,useEffect} from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme,  withStyles, } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
//import DashboardIcon from '@material-ui/icons/Dashboard';
//import PaymentIcon from '@material-ui/icons/Payment';
//import ReceiptIcon from '@material-ui/icons/Receipt';
import DashboardIcon from '@material-ui/icons/Adjust';
import PaymentIcon from '@material-ui/icons/Adjust';
import ReceiptIcon from '@material-ui/icons/Adjust';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import axios from "axios"
import { base_url } from '../globalConstants';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import { UncontrolledCollapse,Form, Collapse, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ButtonToggle } from "reactstrap";
import {Accordion,Button,DropdownButton,ButtonGroup,Dropdown,Modal, Image} from "react-bootstrap"
import { Link , Redirect} from 'react-router-dom';
import { Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-roboto';
import CreditCardInput from 'react-credit-card-input';
import "../App.css"
import DrawerImage from "./Drawer.png"
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

const drawerWidth = 240;


function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Card Authorization
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Status</h4>
       <h3>Card Authorization Succesfull</h3>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}



const useStyles = makeStyles((theme) => ({
  root:{
    display:'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },

 
}));


const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right",
    
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right",
    
  }

const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
}))


export default function ShippingAdd(props){
  const [isOpen, setIsOpen] = useState(false);
 
  const toggle = () => setIsOpen(!isOpen);
    const classes = useStyles();
    const theme = useTheme();
   // const [open, setOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
   
  

  const [username,setusername]=useState('')
  const [userDetails, setUserDetails]=useState('')
  const [validated,setValidated]=useState(false);
  const [EzzId,setEzzId]=useState('')
  const [userLanguage, setUserLanguage] = useState('');
  const history = useHistory();
  
  const onHome = async () => {
		history.push('/customerdashboard');
	}
	
  const handleLanguageChange =  e =>  {
    axios({
      method: 'patch',
      url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
      data: {'language':e},
      headers: { 'Content-Type': 'application/json' },
      
    }).then(function(response){
      console.log(response)
      console.log(response.data)
      setUserLanguage(e)
      toast(`Your Language has been changed to ${e}`)

      })
      .catch(function(response){
      console.log(response)
    })
    } 

    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const checkUserAddress = () => {

      axios({
        method: 'get',
        url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
        headers: { 'Content-Type': 'application/json' }
      }).then(function(response){
        console.log(response)
        console.log(response.data)
  
        const userDetails =  response.data
  
        setUserDetails(userDetails)
        setUserLanguage(response.data.language)
    
      }).catch(function(response){
        console.log(response);
      })
  
     
  
    }

    useEffect(()=>{

      setusername(localStorage.getItem('username'));
      setValidated(localStorage.getItem('validated'));
      setEzzId(localStorage.getItem('ezzyid'));

      checkUserAddress()
    
     },[])

    return (
        <div  className={classes.root}>
        {localStorage.getItem('logged') ==='true' ? ' ': <Redirect to="/"/>}
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar style={{backgroundColor:"white"}}>
            <IconButton
              color="Blue"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
          <Image src="assets/images/group-4-copy.png" />  
          <h6 style={{ marginTop:"1.5%", marginLeft:"15%", color:"blue"}}>ID:{EzzId}</h6>                  
          {/* <Typography variant="h4" id="ezzy" noWrap >
            EzzyShip
          </Typography> */}
		  {/*<IconButton float="right" style={{marginLeft:"40%" }}> <HelpOutlineIcon style={{color:"#4C4B4B",width:"30px",height:"30px"}}/></IconButton>*/}
         <IconButton float="right" style={{marginLeft:"20%" }}> </IconButton>
         
		 
			 {/*<PersonPinIcon  style={{color:"#4C4B4B",width:"40px",height:"40px"}}/>*/}
         <DropdownButton id="bg-vertical-dropdown-1" edge="end" title={userLanguage} className='myAccountDropdown'>
         <Dropdown.Item as={ButtonGroup} onClick={()=>handleLanguageChange('English')}>English</Dropdown.Item>
         <Dropdown.Item as={ButtonGroup}onClick={()=>handleLanguageChange('Spanish')}>Spanish</Dropdown.Item>
         </DropdownButton>
         <DropdownButton id="bg-vertical-dropdown-1" edge="end" title="My Account " className='myAccountDropdown'> 
        <Link to="/userprofile"><Dropdown.Item as={ButtonGroup}>My Profile</Dropdown.Item></Link>
        <Link to="/"> <Dropdown.Item as={ButtonGroup} onClick={()=>{
          localStorage.removeItem("token");
          localStorage.removeItem("ezzname");
          localStorage.removeItem("ezzyid");
          localStorage.removeItem("username")
          localStorage.setItem('logged', 'false');
          //setLogged(false);

        }} eventKey="2">Sign Out</Dropdown.Item></Link>

              <Dropdown.Divider />
              <div style={{ textAlign: 'center', backgroundColor: '#80808021' }}>
                <h6>My EzzyShip Address</h6>
                <p>
				{localStorage.getItem("username")}<br/>
				{localStorage.getItem("ezzyid")}<br/>
                    12281 SW 132ND CT STE A<br/>
                    MIAMI FL 33186-6478<br/>
					Ph: +1(786)842-3145<br/>
                </p>
              </div>

            </DropdownButton>
          </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>
          <Divider />
          <List style={{backgroundColor: "transparent"}} id="listleft">


          <Link to="/customerdashboard"  ><ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <DashboardIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Dashboard' primary="DashBoard" />
                </ListItem></Link>
                                <Link to="/orderlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Order List' primary="Invoice Missing" />
                </ListItem></Link>  
                <Link to="/orderlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Order List' primary="My Orders" />
                </ListItem></Link>  

                <Link to="/paymentauth"><ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Payment Authorization' primary="Add Payment" />
                </ListItem></Link>
                <Link to="/calculator">
                <ListItem button>
                    <ListItemIcon  style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Calculator' primary="EZZY Estimator" />
                </ListItem>
                </Link> 
                <Link to="/referrallist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Referral' primary="Refer A Friend" />
                </ListItem></Link>
                 <Link to="/couponlist"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>
                    <ListItemText  style={{height:"2px"}} title='Coupon List' primary="My Coupons" />
                </ListItem></Link> 
				<Link to="/changepwd">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Change Password' primary="Change Password" />
                </ListItem>
                </Link> 
				<Link to="/shippingadd">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Shipping Address' primary="Shipping Address" />
                </ListItem>
                </Link> 
                <Link to="/changemethod">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}} > <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Change Shipping' primary="Change Shipping" />
                </ListItem>
                </Link> 
				                      <Link to={{pathname:"https://youtu.be/Hk1RFcpq20g"}} target="_blank">	
                  <ListItem button>	
                      <ListItemIcon style={{height:"2px"}}> <ReceiptIcon /></ListItemIcon>	
                      <ListItemText  style={{height:"2px"}} title='How We Work' primary="How We Work" ></ListItemText>	
                  </ListItem>	
				    </Link> 				

               

                                <Link to="/contact"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <DashboardIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Contact Us' primary="Contact Us" />
                </ListItem></Link>
                <Link to="/customerdashboard"><ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} title='Self Help' primary="Self Help" />
                </ListItem></Link>
               
				<Link to="/changepwd">
                <ListItem button>
                    <ListItemIcon style={{height:"2px"}}> <PaymentIcon /></ListItemIcon>
                    <ListItemText style={{height:"2px"}} onClick={() => {
                            localStorage.removeItem("token");
                            localStorage.removeItem("ezzname");
                            localStorage.removeItem("ezzyid");
                            localStorage.removeItem("username")
                            localStorage.setItem('logged', 'false'); 

                          }} title='Sign Out' primary="Sign Out" />
                </ListItem>
                </Link>
         
</List>

         
          <Divider />
  
         
  
       <img src={DrawerImage} style={{ marginLeft:"5%", height: "230px", width: "200px", marginTop: "30%" }} />
  
          
        </Drawer>
        <main style={{backgroundColor:"white"}}
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <div className={classes.drawerHeader} />
      <div style={{ float: 'center' }}>
	  <br/><br/>
        <h2 className="general-heading" >Shipping Address</h2><br/>
		<h5 style={{ float: 'center' } }>USA Address:</h5>
        <div style={{ float: 'center' }}>{localStorage.getItem("username")}<br/>{localStorage.getItem("ezzyid")}<br/>12281 SW 132ND CT STE A<br/>MIAMI FL 33186-6478<br/>Ph: +1(786)842-3145<br/><br/></div>
		
		<h5 style={{ float: 'center' }} >CHINA Address:</h5>
        <div style={{ float: 'center' }}>{localStorage.getItem("ezzname")}<br/>{localStorage.getItem("ezzyid")}<br/>Room ID-7046<br/>4th Floor, Building 36, Cuigang Industrial Zone 5<br/>Huide Community, Fuyong Street<br/>Baoan District, Shenzhen City<br/>Guangdong, China<br/>Telephone: 18126324875<br/>Zip code: 518103</div><br/><br/>
		<Button id="btnhome" className="btnCalculate" variant="primary" type='button' size='lg' block                                         
                                            onClick= { onHome  }>Home</Button>	
      </div>
        
        </main>
		
		
										
										
                                    
		
        </div>
		

    )
}
